import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteKey from './key';

const ErrorPage = lazy(() => import('../pages/error/Error'));
const Invalid = lazy(() => import('../pages/error/Invalid'));
const NotExist = lazy(() => import('../pages/error/NotExist'));
const Generic = lazy(() => import('../pages/error/Generic'));
const Unauthorized = lazy(() => import('../pages/error/Unauthorized'));
const Maintenance = lazy(() => import('../pages/error/Maintenance'));
const ServiceUnavailable = lazy(() => import('../pages/error/ServiceUnavailable'));
const InvalidLink = lazy(() => import('../pages/error/InvalidLink'));
const ServerBusy = lazy(() => import('../pages/error/ServerBusy'));

const {
  authorized,
  invalid,
  serverError,
  serviceUnavailable,
  serverNotFound,
  generic,
  invalidLink,
  maintenance,
  serverBusy,
} = RouteKey.error.child;

const ErrorRoute = () => {
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path={`${path}`}>
          <NotExist />
        </Route>

        <Route path={`${path}/${serverNotFound}`}>
          <NotExist />
        </Route>

        <Route path={`${path}/${serverError}`}>
          <ErrorPage />
        </Route>

        <Route path={`${path}/${invalidLink}`}>
          <InvalidLink />
        </Route>

        <Route path={`${path}/${serviceUnavailable}`}>
          <ServiceUnavailable />
        </Route>

        <Route path={`${path}/${serverBusy}`}>
          <ServerBusy />
        </Route>

        <Route path={`${path}/${authorized}`}>
          <Unauthorized />
        </Route>

        <Route path={`${path}/${invalid}`}>
          <Invalid />
        </Route>

        <Route path={`${path}/${generic}`}>
          <Generic />
        </Route>

        <Route path={`${path}/${maintenance}`}>
          <Maintenance />
        </Route>

        <Route path="*" exact>
          <Redirect to={`${path}`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default ErrorRoute;
